import { adminPanelConfig } from '@Modules/adminpanel/routes';
import { authConfig } from '@Modules/auth/routes';
import {transactionsConfig} from '@Modules/Transactions/routes';
import { dealsConfig } from '@Modules/Deals/routes';
import {transactionCurrencyConfig} from '@Modules/TransactionCurrency/routes';
import {accountsConfig} from '@Modules/accounts/routes';
import { clientsConfig } from '@Modules/clients/routes';
import { clientConfig } from '@Modules/client/routes';

export const routesConfig = [
	...authConfig,
	...adminPanelConfig,
	...transactionsConfig,
	...dealsConfig,
	...transactionCurrencyConfig,
	...accountsConfig,
	...clientsConfig,
	...clientConfig
];
